import React, { useEffect, useState } from "react";
import { Box, Typography, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const SignaturesSummary = ({ updateSummaryData }) => {
  const { t } = useTranslation();
  const storedData = useSelector(state => state.profiles.summaryData);
  const [summaryData, setSummaryData] = useState({
    clientName: "",
    clientSignature: "",
    clientDate: "",
    witnessSignature: "",
    witnessDate: "",
    caseManagerSignature: "",
    caseManagerDate: "",
  });

  const handleChange = (field, value) => {
    setSummaryData((prevData) => ({
        ...prevData,
        [field]: value
    }));
  };  

  useEffect(() => {
    setSummaryData((prevData) => ({
        ...prevData,
        ...storedData
    }));
  }, [storedData]);

  useEffect(() => {
    updateSummaryData(summaryData)
  }, [summaryData]);

  return (
    <Box sx={{ p: 2, bgcolor: "white", borderRadius: 1 }}>
      <Typography variant="body1" gutterBottom>
        {t("Profiles.Summary.I")}
        <TextField
          value={summaryData.clientName}
          variant="standard"
          sx={{ width: 200 }}
          onChange={(e) => handleChange("clientName", e.target.value)}
        />
        {t("Profiles.Summary.certifythatallthe")}
      </Typography>

      {/* Firma Cliente */}
      <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
        <Typography>{t("Profiles.Summary.Client(guardian)")}</Typography>
        <TextField
          value={summaryData.clientSignature}
          variant="standard"
          sx={{ ml: 1, flexGrow: 1 }}
          onChange={(e) => handleChange("clientSignature", e.target.value)}
        />
        <Typography sx={{ ml: 2 }}>{t("Profiles.Summary.Signature")}</Typography>
        <TextField
          value={summaryData.clientDate}
          variant="standard"
          sx={{ width: 150, ml: 1 }}
          type="date"
          onChange={(e) => handleChange("clientDate", e.target.value)}
        />
      </Box>

      {/* Firma Testigo */}
      <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
        <Typography>{t("Profiles.Summary.*WitnessSignature(ifneeded)")}</Typography>
        <TextField
          value={summaryData.witnessSignature}
          variant="standard"
          sx={{ ml: 1, flexGrow: 1 }}
          onChange={(e) => handleChange("witnessSignature", e.target.value)}
        />
        <Typography sx={{ ml: 2 }}>{t("Profiles.Summary.Date")}</Typography>
        <TextField
          value={summaryData.witnessDate}
          variant="standard"
          sx={{ width: 150, ml: 1 }}
          type="date"
          onChange={(e) => handleChange("witnessDate", e.target.value)}
        />
      </Box>

      {/* Firma Case Manager */}
      <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
        <Typography>{t("Profiles.Summary.CaseManagerSignature")}</Typography>
        <TextField
          value={summaryData.caseManagerSignature}
          variant="standard"
          sx={{ ml: 1, flexGrow: 1 }}
          onChange={(e) => handleChange("caseManagerSignature", e.target.value)}
        />
        <Typography sx={{ ml: 2 }}>{t("Profiles.Summary.Date")}</Typography>
        <TextField
          value={summaryData.caseManagerDate}
          variant="standard"
          sx={{ width: 150, ml: 1 }}
          type="date"
          onChange={(e) => handleChange("caseManagerDate", e.target.value)}
        />
      </Box>
    </Box>
  );
};

export default SignaturesSummary;
